<template>
  <div v-if="store.state.eshop.eshop">
    <div id="main-content" class="container container-container bg-white">
      <div id="main" class="pt-3 pb-5 mb-5">
        <pending-config-gate v-if="pendingGateKey" :config-key="pendingGateKey" />
        <router-view v-else />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import PendingConfigGate from '@/app/components/Utils/PendingConfigGate.vue'

const store = useStore()
const router = useRouter()
const route = useRoute()

const eshop = computed(() => store.state.eshop.eshop)
const isActiveEshop = computed(() => eshop.value?.status === 'ACTIVE')

// Maps each required config key to the route families that need it resolved.
// Add future gating configs here — no new plumbing required.
const GATED_ROUTES = {
  UNIQUE_SKU: (r) => r.matched.some(m => ['Inventory', 'Insights'].includes(m.name))
}

const pendingGateKey = computed(() => {
  if (store.state.user?.adminAssumed) return null
  const pending = store.state.eshop.eshop?.pending_configs || []
  return pending.find(key => GATED_ROUTES[key]?.(route) ?? false) || null
})

onMounted(() => {
  store.dispatch('eshop/getSourceCategories')
  store.dispatch('eshop/getSourceLocations')
  store.dispatch('eshop/getEbayConnectionState')
})

if (!isActiveEshop.value) {
  router.replace({ name: 'Home' })
}
</script>
